import React from 'react';
import { flexRender, Table } from '@tanstack/react-table';
import { DetailsTableRow } from '../types';

interface DetailsTableProps {
  table: Table<DetailsTableRow>;
}

const baseString = 'details-table';
export function DetailsTable({ table }: DetailsTableProps) {

  return (
    <table className={baseString} data-test-id="details-table">
      <thead>
        {table.getHeaderGroups().map((hg) => (
          <tr key={hg.id}>
            {hg.headers.map((header) => (
              <th key={header.id} data-test-id={`header-${header.id}`}>
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext()
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr
            key={row.id}
          >
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id} data-test-id={`cell-${cell.id}`}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

